<template>
    <div>
        <div class="setting-group">
            <div class="setting">
                <UAlert
                    description="Godkjenningsflyt er i en tidlig alfa-testversjon. Forvent endringer i fremtiden."
                    color="warning"
                    variant="outline"
                    icon="i-ph-warning"
                    class="mt-2 mb-4"
                />
                Velg status for innkommende dokument
                <URadioGroup
                    v-model="standardIncomingDocumentStatus"
                    class="my-2"
                    variant="table"
                    orientation="horizontal"
                    :items="[{
                        label: 'Til godkjenning',
                        description: 'Innkommende bilag vil få status \'Venter\' og må godkjennes før de kan bokføres.',
                        value: false,
                    }, {
                        label: 'Til bokføring',
                        description: 'Innkommende bilag blir automatisk godkjent og vil ligge klare for bokføring.',
                        value: true
                    }]"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

import {computed} from 'vue'
import {useSetting} from '@/setting/setting.service'

const {setting} = useSetting<string>('DEFAULT_INCOMING_DOCUMENT_STATUS')

const standardIncomingDocumentStatus = computed({
    get: () => (setting.value?.value ?? 'APPROVED') === 'APPROVED',
    set: async (value: boolean) => {
        setting.value.value = value ? 'APPROVED' : 'PENDING'
    }
})

</script>

<style scoped>

</style>